export default {
  setWebData(state, data) {
    state.webData = data
  },

  setUserinfo(state, data) {
    state.userinfo = data
  },

  setRoomId(state, data) {
    state.room_id = data
  },

  setStageList(state, data) {
    state.stage_list = data
  },

  setPkType(state, data) {
    state.pkType = data
  },
}
